module.exports = __webpack_public_path__ + "img/full5-min.7297a667.png";